import { eduIDApi } from "./common";
export const jsConfigApi = eduIDApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchJsConfig: builder.query({
            query: () => ({
                url: "",
            }),
            extraOptions: { service: "jsConfig" },
        }),
    }),
});
